import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import store from '@state/store'
import {
  MdButton,
  MdContent,
  MdCard,
  MdField,
  MdList,
  MdToolbar,
  MdAvatar,
  MdProgress,
  MdDialog,
  MdBottomBar,
  MdMenu
} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import { VuePlausible } from 'vue-plausible'

// sentry error logging
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { RewriteFrames } from '@sentry/integrations'

const { version } = require('../package.json')

Sentry.init({
  Vue: Vue,
  dsn:
  "https://67dde1aebba148739c964d09cd001895@o446669.ingest.sentry.io/5541923",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  autoSessionTracking: true,
  logErrors: true,
  integrations: [new Integrations.BrowserTracing(), new RewriteFrames()],
  release: version,
  sampleRate: 0.1,
  tracesSampleRate: 0.1,
  attachStacktrace: true,
  tracingOptions: {
    trackComponents: true,
  },
})
Sentry.setTag('in-app-support', version)
Sentry.setContext('Support', {
  version: version,
})


// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdList)
Vue.use(MdToolbar)
Vue.use(MdAvatar)
Vue.use(MdProgress)
Vue.use(MdDialog)
Vue.use(MdBottomBar)
Vue.use(MdMenu)

Vue.use(VuePlausible, {
  // see configuration section
  buildModules: [
    'vue-plausible'
  ],
  enableAutoPageviews: true,
  enableAutoOubundTracking: true,
  plausible: { // Use as fallback if no runtime config is available at runtime
    // called from
    domain: 'ias.outfit7.net'
  }
})

Vue.filter('striphtml', function (value) {
  var div = document.createElement('div')
  div.innerHTML = value
  var text = div.textContent || div.innerText || ''
  return text
})


const app = new Vue({
  router,
  store,
  render: (h) => h(App),
})
store.$app = app
app.$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
